import api from '@/utils/api';

/**
 * delete company
 *
 * @param {string} companyId - The company id
 * @returns {Promise} The promise object of the api call
 */
const deleteCompanyApi = (companyId) => api.delete(`company/${companyId}`);

export default deleteCompanyApi;
